import useTranslator from "../hooks/useTranslator";
import {
  getNotificationDisplayText,
  groupNotificationsByDate,
} from "../helper/common";
import { NotificationCard } from "./design";

/**
 * Notifications grouped by day: the date and its unread count, then one
 * NotificationCard per notification. Used by the workspace dashboard and
 * the Notifications page; each passes its own avatar, meta line and click.
 */
const NotificationGroups = ({
  notifications = [],
  getAvatar,
  getMeta,
  onOpen,
}) => {
  const { _t } = useTranslator();
  const groups = Object.entries(groupNotificationsByDate(notifications));

  return groups.map(([date, items], index) => (
    <div key={date} className="notification-wrapper-main d-flex custom-gap-3">
      <div
        className={`notification-info-time ${
          index === groups.length - 1 ? "last-child" : ""
        }`}
      >
        <h5>{date}</h5>
        <p>
          {items.filter((n) => !n.marked_read).length} {_t("unread")}
        </p>
      </div>
      <div className="d-flex flex-column notification-info-main">
        {items.map((notification) => (
          <NotificationCard
            key={notification?._id}
            unread={!notification?.marked_read}
            title={getNotificationDisplayText(notification, _t)}
            avatar={getAvatar?.(notification)}
            meta={getMeta?.(notification)}
            onClick={() => onOpen(notification)}
          />
        ))}
      </div>
    </div>
  ));
};

export default NotificationGroups;
